import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './Components/HomePage';
import Overview from './Components/Overview';
import Contact from './Components/Contact';
import StrategyAndProcess from './Components/StrategyAndProcess';
import Ourwork from './Components/Ourwork';
import OurCoreWorks from './Components/OurCoreWorks';
import ToolsAndMonitoring from './Components/ToolsAndMonitoring';
import SocialMedia from './Components/SocialMedia';
import DigitalMarketing from './Components/DigitalMarketing';
import SEOContent from './Components/SEOContent';
import UIUXBranding from './Components/UIUXBranding';
import BrandingLanding from './Components/BrandingLanding';
import SoftwareLanding from './Components/SoftwareLanding';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/about-us" element={<Overview />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/strategy-and-architecture" element={<StrategyAndProcess />} />
        <Route path="/case-studies" element={<Ourwork />} />
        <Route path="/software-solutions" element={<OurCoreWorks />} />
        <Route path="/tech-stack" element={<ToolsAndMonitoring />} />
        {/* Landing pages */}
        <Route path="/branding" element={<BrandingLanding />} />
        <Route path="/software-development" element={<SoftwareLanding />} />
        {/* Branding sub-pages */}
        <Route path="/social-media" element={<SocialMedia />} />
        <Route path="/digital-marketing" element={<DigitalMarketing />} />
        <Route path="/seo-content" element={<SEOContent />} />
        <Route path="/uiux-branding" element={<UIUXBranding />} />
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;